import React from "react";
import Hero from "../components/home/Hero";
import Stats from "../components/home/Stats";
import AboutPreview from "../components/home/AboutPreview";
import Categories from "../components/home/Categories";
import FeaturedProducts from "../components/home/FeaturedProducts";
import WhyChoose from "../components/home/WhyChoose";
import GlobalReach from "../components/home/GlobalReach";
import Certifications from "../components/home/Certifications";
import { Process, Testimonial } from "../components/home/Process";
import LatestPosts from "../components/home/LatestPosts";

export default function Home() {
  return (
    <>
      <Hero />
      <Stats />
      <AboutPreview />
      <Categories />
      <FeaturedProducts />
      <WhyChoose />
      <GlobalReach />
      <Certifications />
      <Process />
      <Testimonial />
      <LatestPosts />
    </>
  );
}
